import Proxy from '../Proxy';

class DamageProxy extends Proxy {
  /**
   * The constructor for the EstimationComplexProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('damages', parameters);
  }
}

export default DamageProxy;
